import { SETTING, useEffectiveSettings } from '../../hooks/use-effective-settings';

/**
 * Whether this organization is on Notification Rules (Alert Notifications v2),
 * a POM Master setting that is off by default. Off: the Notifications page is
 * hidden, Settings keeps its own Notify On Dispatch editor, and the Groups &
 * Teams screens say what they said before v2, matching the API, which routes
 * alerts exactly as before for these organizations.
 */
export const useNotificationRulesEnabled = (): boolean => {
    const { getSetting } = useEffectiveSettings();
    return getSetting<boolean>(SETTING.notificationRules, false);
};
